export default __webpack_public_path__ + "static/media/illustration.451dd7c3.png";